<template>
    <base-modal
      :ref="modal.key"
      :show="open"
      :title="modalTitle"
      :showConfirmButton="false"
      :showCancelButton="false"
      :loadingContent="loading"
    >
        <v-text-field
          v-bind:label="$t('Password')"
          v-model="password"
          maxlength="100"
          :error-messages="passwordErrors"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          @keydown.enter.prevent="sendPassword"
        ></v-text-field>

        <div class="d-flex justify-end">
          <v-btn
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            :loading="loading"
            @click="hide"
          >
            {{ $t('Close') }}
          </v-btn>
          <v-btn
            color="primary"
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            :loading="loading"
            @click="sendPassword"
          >
            {{ $t('Login') }}
          </v-btn>
        </div>
        <div v-if="!isAdmin">
            <template v-if="loginParams.saml && loginParams.saml.show">
                <div class="d-flex align-center my-4">
                    <v-divider></v-divider>
                    <span class="caption grey--text px-2">{{ $t('ContinueWith') }}</span>
                    <v-divider></v-divider>
                </div>
                <v-btn
                    block
                    outlined
                    :height="45"
                    @click="samlLogin"
                    class="text-none rounded-lg ma-0"
                    color="grey"
                >
                    <img
                    :src="loginParams.saml.iconSrc"
                    class="mr-3"
                    style="max-height: 15px;"
                    />
                </v-btn>
            </template>

            <!-- Entra ID Login -->
            <template v-if="loginParams.entraId && loginParams.entraId.show">
                <div v-if="!loginParams.saml || !loginParams.saml.show" class="d-flex align-center my-4">
                    <v-divider></v-divider>
                    <span class="caption grey--text px-2">{{ $t('ContinueWith') }}</span>
                    <v-divider></v-divider>
                </div>
                <v-btn
                    outlined
                    block
                    color="primary"
                    :height="45"
                    @click="signInWithEntraid"
                    class="text-none mt-2"
                >
                    <img
                    :src="loginParams.entraId.iconSrc"
                    :alt="$t('Entra ID')"
                    style="object-fit: cover; max-height: 20px"
                    class="mr-3"
                    />
                    {{
                    loginParams.entraId.customText ||
                    $t("SignInWith") + " Entra ID"
                    }}
                </v-btn>
            </template>
        </div>
    </base-modal>
  </template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
    name: 'ConfirmPasswordModal',
    data() {
        return {
            modal: {
                title: this.$t('Site.Delegations.EnterPassword'),
                key: 'confirmPasswordModal',
            },
            open: false,
            password: '',
            showPassword: false,
            loading: false,
            loginParams: this.$store.getters['account/loginParams'],
            isAdmin: this.$store.getters['account/user'].IsAdmin
        };
    },
    mixins: [validationMixin],
    validations: {
        password: { required }
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return this.modal.title;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.required && errors.push(this.$t('RequiredField'));
            return errors;
        }
    },
    methods: {
        sendPassword() {
            this.$v.$touch();
            this.loading = true;
            if (this.$v.$invalid) {
                this.loading = false;
                return;
            }
            this.$emit('password-confirmed', this.password);
        },
        samlLogin() {
            this.loading = true;
            this.$emit('saml-login');
        },
        signInWithEntraid() {
            this.loading = true;
            this.$emit('entraid-login');
        },
        new() {
            this.password = '';
            this.$v.$reset();
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        }
    },
};
</script>
